import { render, staticRenderFns } from "./slide-banner.vue?vue&type=template&id=448f65c6&scoped=true&"
import script from "./slide-banner.vue?vue&type=script&lang=js&"
export * from "./slide-banner.vue?vue&type=script&lang=js&"
import style0 from "./slide-banner.vue?vue&type=style&index=0&id=448f65c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f65c6",
  null
  
)

export default component.exports